import { initializePermissionApi, PermissionApi } from '@data-delivery/permission-ui-api';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { sftpUsersKeys } from './sftp-users-keys';

const sftpUsersApi = initializePermissionApi(PermissionApi.SFTPUsersApi);

export function useSearchSftpUsersByLoginIdRQ(loginFragment: string) {
  const enabled = loginFragment.trim().length >= 2;
  return useQuery(
    queryOptions({
      queryKey: [...sftpUsersKeys.all(), 'search-login-fragment', loginFragment] as const,
      enabled,
      async queryFn() {
        if (enabled) {
          try {
            const { data } = await sftpUsersApi.searchUserByLoginId({ searchId: loginFragment });
            return data ?? [];
          } catch {
            const { data } = await sftpUsersApi.listVisibleUsers();
            return (data ?? []).filter((u: PermissionApi.UserEntity) =>
              (u.loginId || '').toLowerCase().includes(loginFragment.toLowerCase()),
            );
          }
        }

        return [];
      },
      staleTime: 30_000,
    }),
  );
}
